import { jsx } from 'theme-ui';
import { Box } from './box';
const SmallUnderlineLink = ({ display = 'flex', color = 'leafyGreen', ...rest }) => (jsx(Box, Object.assign({ display: display, sx: {
        fontFamily: 'primary',
        py: 'none',
        pb: '2px',
        borderRadius: 'none',
        border: 'initial',
        borderBottom: '2px solid',
        borderColor: color || 'leafyGreen',
        fontSize: '14px',
        lineHeight: '22px',
        color: color || 'leafyGreen',
        fontWeight: 'bold',
        bg: 'transparent',
        cursor: 'pointer',
        px: 'none',
        '&:hover:not([disabled])': {
            color: color || 'greenCTAHover',
            borderColor: color || 'greenCTAHover',
            transition: 'all',
            transform: 'scale(1.02)'
        }
    } }, rest), rest.children));
export default SmallUnderlineLink;
//# sourceMappingURL=small-underline-link.js.map